import { EmojiCategoryData, EmojiData, EmojiProvider } from '../EmojiModel';
import { EmojiSprite } from '../EmojiSprite';

require('./twemoji.css');
const emojiData = require('./emoji.json');
const categoryJson = require('./categories.json');

export const TwemojiEmojis: Readonly<EmojiData[]> = (() => {
    emojiData.forEach((x: any) => x.source = 'twemoji');
    return emojiData as EmojiData[];
})();

export const TwemojiCategories: Readonly<EmojiCategoryData[]> = (() => {
    return categoryJson as EmojiCategoryData[];
})();

export class TwemojiProvider implements EmojiProvider {
    public getEmoji = () => TwemojiEmojis;
    public getCategories = () => TwemojiCategories;
}

export class TwemojiSprite implements EmojiSprite {

    public static async load(uri: string): Promise<TwemojiSprite> {
        return new Promise<TwemojiSprite>((rs, rj) => {
            const i = new Image();
            i.crossOrigin = 'anonymous';
            i.onload = () => rs(new TwemojiSprite(58, 72, i));
            i.onerror = (e, s, fn, cn, err) => rj(err);
            i.src = uri;
        });
    }

    public readonly columns: number;
    public readonly cellSize: number;
    public readonly data: CanvasImageSource;

    private constructor(columns: number, cellSize: number, data: CanvasImageSource) {
        this.columns = columns;
        this.cellSize = cellSize;
        this.data = data;
    }
}
